import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function calcAge(birthday) {
  if (!birthday) return null;
  const b = new Date(birthday);
  if (isNaN(b.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - b.getFullYear();
  const m = now.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < b.getDate())) age--;
  return age >= 0 ? age : null;
}

export function calcAgeMonths(birthday) {
  if (!birthday) return null;
  const b = new Date(birthday);
  if (isNaN(b.getTime())) return null;
  const now = new Date();
  let months = (now.getFullYear() - b.getFullYear()) * 12 + (now.getMonth() - b.getMonth());
  if (now.getDate() < b.getDate()) months--;
  return months >= 0 ? months : null;
}

export function formatAge(birthday, t) {
  const months = calcAgeMonths(birthday);
  if (months == null) return null;
  if (months < 36) {
    return `${months} ${t("monthsUnit")}`;
  }
  const years = Math.floor(months / 12);
  const rem = months % 12;
  return rem > 0
    ? `${years} ${t("yearsUnit")} ${rem} ${t("monthsUnit")}`
    : `${years} ${t("yearsUnit")}`;
}

// Host dashboard age format: under 24 months -> months ("18 ay"),
// 24 months and older -> whole years ("3 yaş").
export function formatAgeHost(birthday, t) {
  const months = calcAgeMonths(birthday);
  if (months == null) return null;
  if (months < 24) return `${months} ${t("monthsUnit")}`;
  return `${Math.floor(months / 12)} ${t("yearsUnit")}`;
}

export function isUnder24Months(birthday) {
  const m = calcAgeMonths(birthday);
  return m != null && m < 24;
}

export function fmtTime(iso) {
  if (!iso) return "--";
  let s = iso;
  // Backend timestamps are UTC but may lack a timezone suffix — treat as UTC
  if (typeof s === "string" && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) {
    s = s + "Z";
  }
  const d = new Date(s);
  if (isNaN(d.getTime())) return "--";
  return d.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Istanbul",
  });
}

export function fmtElapsed(mins, t) {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h > 0) return `${h}${t("hours")} ${m}${t("minutes")}`;
  return `${m}${t("minutes")}`;
}
